// extracted by mini-css-extract-plugin
export default {"root":"Invoice_root__62Cpu"};